const ETH = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.99919 0L16.0787 10.0461L10.0217 7.45733L9.99919 0Z"
      fill="#E68F7B"
    />
    <path
      d="M3.93622 10.0461L9.9991 0L10.0216 7.45733L3.93622 10.0461Z"
      fill="#F8EC7C"
    />
    <path
      d="M9.9991 13.75L3.93622 10.0458L10.0216 7.457L9.9991 13.75Z"
      fill="#6EB87D"
    />
    <path
      d="M16.0787 10.0458L10.0217 7.457L9.99919 13.75L16.0787 10.0458Z"
      fill="#946BA7"
    />
    <path
      d="M9.99919 15.0254L16.0787 11.4215L9.99919 19.9878V15.0254Z"
      fill="#697CB9"
    />
    <path
      d="M9.9991 15.0254L3.93622 11.4215L9.9991 19.9878V15.0254Z"
      fill="#4FADD0"
    />
  </svg>
);
export default ETH;
